import { largePriceFormat, priceFormat } from '@/utils/number'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import 'dayjs/locale/zh-cn';
import { startsWith } from "lodash-es";
import { join, promoteUrl } from "@/utils/url";
dayjs.locale('zh-cn');
dayjs.extend(relativeTime);

class VueFilters {
  /**
   *
   * @param Vue
   * @returns {Promise<void>}
   */
  async install (Vue) {
    Vue.config.globalProperties.$filters = {
      // 文字过长会变成 ...
      more (value, length = 10, mask = '...') {
        if (value.length <= length) {
          return value
        }
        return value.substr(0, length) + mask
      },

      // 千分位小数点 ...
      priceFormat (value, fix = 2) {
        return priceFormat(value, fix)
      },

      // 千分位小数点,整数值不显示小数 （金额：整数无小数点，四舍五入）eg1： 441000.5258 ==》 441,000.52    eg2：1876273 ==》 1,876,273
      priceFormatInt (value, fix = 2) {
        return priceFormat(value, fix, false)
      },

      // 加上万字  ...
      largePriceFormat (value) {
        return largePriceFormat(value, 0)
      },

      dateFormat (value, format = 'YYYY-MM-DD HH:mm:ss') {
        return dayjs(value).format(format)
      },

      // 返回 幾分鐘前 幾小時前 MM-DD YYYY-MM-DD 超過22小時會跳1天前.手動抓
      dateDurationFormat(value) {
        if(dayjs().diff(dayjs(value),'year') > 0 || !dayjs().isSame(dayjs(value),'year')) {
          return dayjs(value).format('YYYY-MM-DD')
        } else if (dayjs().diff(dayjs(value),'hour') >= 24) {
          return dayjs(value).format('MM-DD')
        } else if (dayjs().diff(dayjs(value),'hour') >= 22) {
          return dayjs().diff(dayjs(value),'hour')+'小时前';
        } else {
          return dayjs(value).fromNow().replace(/\s/g,'').replace('几秒前','1分钟前')
        }
      },

      // 套用CDN選址域名
      cdnUrlFormat (src) {
        // base64 图片不做任何处理
        if (startsWith(src, 'data:')) {
          return src
        }
        if(process.env.NODE_ENV === 'development') {
          return '/n/' + src
        }
        // 图片走 cdn
        if (src &&
            // 开头有 http 或双斜线都不加 cdn
            (!startsWith(src, 'http') && !startsWith(src, '//')) &&
            // 正式环境或非本地资源一律加上 cdn
            (process.env.NODE_ENV === 'production' || src.indexOf('assets/img') === -1)) {
          // Vue本地圖片、非台灣開發IP 加上n路徑
          if (src.startsWith('img/') && !window.yunweiConfig.imageServer.startsWith('http://10.82.5')) src = 'n/' + src
          src = join(window.yunweiConfig.imageServer, src)
        }

        return src
      },

      promoteUrl (url) {
        return promoteUrl() + url
      },

      highlight (word, query) {
        let check = new RegExp(query, "ig");
        return word.toString().replace(check, function(matchedText,a,b){
          return ('<span class="filter-highlight">' + matchedText + '</span>');
        });
      }
    }
  }
}

export default new VueFilters()
